export const API_URL: string = import.meta.env.VITE_APP_API_URL;
export const APP_URL: string = import.meta.env.VITE_APP_APP_URL;
export const APP_MODE = import.meta.env.MODE as "development" | "production" | "stage";
export const SEND_XDEBUG_SESSION_START: boolean = import.meta.env.VITE_SEND_XDEBUG_SESSION_START === "true";

export const PUSHER_APP_KEY: string = import.meta.env.VITE_PUSHER_APP_KEY;
export const PUSHER_CLUSTER: string = import.meta.env.VITE_PUSHER_CLUSTER;
